import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";

export const CoursePlayerApi = createApi({
  reducerPath: "CoursePlayerApi",
  baseQuery: customBaseQuery,
  //   keepUnusedDataFor: 60,
  //   tagTypes: ["contentFaq"],
  endpoints: (builder) => ({
    getCourse: builder.query({
      query: ({ id }: any) => {
        return {
          url: `/course`,
          method: "GET",
          params: {
            id: `${id}`
          }
        };
      },
      extraOptions: { service: "Course_Controller" }
    }),
    postCourse: builder.mutation({
      query: (data) => {
        return {
          url: `/course`,
          method: "POST",
          body: data
        };
      },
      extraOptions: { service: "Course_Controller" }
    }),
    postCourseById: builder.mutation({
      query: ({ courseData, courseId }) => {
        return {
          url: `/course/${courseId}`,
          method: "POST",
          body: courseData
        };
      },
      extraOptions: { service: "Course_Controller" }
    }),
    putCourseStatus: builder.mutation({
      query: ({ data, courseId }) => {
        return {
          url: `/course/status/${courseId}`,
          method: "PUT",
          body: data
        };
      },
      extraOptions: { service: "Course_Controller" }
    }),
    deleteCourse: builder.query({
      query: ({ id, remarks }: any) => {
        return {
          url: `/course/${id}`,
          method: "DELETE",
          body: {
            remarks: remarks
          }
        };
      },
      extraOptions: { service: "Course_Controller" }
    }),
    courseCloneById: builder.query({
      query: (courseId) => ({
        url: `/course/cloneCourse/${courseId}`,
        method: "POST"
      }),
      extraOptions: { service: "Course_Controller" }
    }),
    postModule: builder.mutation({
      query: (data) => {
        return {
          url: `/course/module`,
          method: "POST",
          body: data
        };
      },
      extraOptions: { service: "Course_Controller" }
    }),
    postModuleById: builder.mutation({
      query: ({ data, moduleId }) => {
        return {
          url: `/course/module/${moduleId}`,
          method: "POST",
          body: data
        };
      },
      extraOptions: { service: "Course_Controller" }
    }),
    deleteModule: builder.mutation({
      query: ({ moduleId, data }) => {
        return {
          url: `/course/module/${moduleId}`,
          method: "DELETE",
          body: data
        };
      },
      extraOptions: { service: "Course_Controller" }
    }),
    postChapter: builder.mutation({
      query: (data) => {
        return {
          url: `/course/chapter`,
          method: "POST",
          body: data
        };
      },
      extraOptions: { service: "Course_Controller" }
    }),
    postChapterById: builder.mutation({
      query: ({ data, contentId }) => {
        return {
          url: `/course/chapter/${contentId}`,
          method: "POST",
          body: data
        };
      },
      extraOptions: { service: "Course_Controller" }
    }),
    deleteChapter: builder.query({
      query: ({ contentId, payload }) => {
        return {
          url: `/course/chapter/${contentId}`,
          method: "DELETE",
          body: payload
        };
      },
      extraOptions: { service: "Course_Controller" }
    }),
    createProgress: builder.mutation({
      query: (id: any) => ({
        url: `/progress/course/create/${id}`,
        method: "GET"
      }),
      extraOptions: { service: "Progress" }
    }),
    validateCourse: builder.query({
      query: (courseId: any) => {
        return {
          url: `/course/validate/${courseId}`,
          method: "GET"
        };
      },
      extraOptions: { service: "Course_Controller" }
    }),
    rearrangeModule: builder.query({
      query: ({ courseId, body }) => ({
        url: `/course/rearrange-module/${courseId}`,
        method: "POST",
        body: body
      }),
      extraOptions: { service: "Course_Controller" }
    }),
    rearrangeChapters: builder.query({
      query: ({ courseId, moduleId, body }) => ({
        url: `/course/rearrange-chapter/${courseId}/${moduleId}`,
        method: "POST",
        body: body
      }),
      extraOptions: { service: "Course_Controller" }
    }),
    postPublishCourseById: builder.mutation<
      any,
      { courseData: any; courseId: string }
    >({
      query: ({ courseData, courseId }) => ({
        url: `/course/post-publish/${courseId}`,
        method: "PUT",
        body: courseData
      }),
      extraOptions: { service: "Course_Controller" }
    })
  })
});

export const {
  useGetCourseQuery,
  useLazyGetCourseQuery,
  usePostCourseMutation,
  usePostCourseByIdMutation,
  usePutCourseStatusMutation,
  useLazyDeleteCourseQuery,
  useLazyCourseCloneByIdQuery,
  useCourseCloneByIdQuery,
  usePostModuleMutation,
  usePostModuleByIdMutation,
  useDeleteModuleMutation,
  usePostChapterMutation,
  usePostChapterByIdMutation,
  useLazyDeleteChapterQuery,
  useCreateProgressMutation,
  useValidateCourseQuery,
  useLazyValidateCourseQuery,
  useLazyRearrangeModuleQuery,
  useLazyRearrangeChaptersQuery,
  usePostPublishCourseByIdMutation
} = CoursePlayerApi;
